import React, { useEffect, useState } from 'react';
import ModalWrapper from '../modals/ModalWrapper';
import { BasicButton } from 'thrive-components';
import { IHttpRequest } from  '@/interfaces/IHttp';
import {IAuthorHistory} from  '@/interfaces/authorHistory';
import { container, TYPES } from  '@/inversifyconfig/container.config';
import { BuildPath } from  '@/helpers/Paths';
import UserDetails from '../elements/authorhistory/UserDetails'
import '../../css/authorHistory.scss'


const AuthorHistoryModal = () => {
    const [open, setOpen] = useState<boolean>(false);
    const [history, setHistory] = useState<IAuthorHistory | null>(null);
    const httpCall = container.get<IHttpRequest>(TYPES.IHttpRequest);

    useEffect(() => {
        (window as any).authorHistory = {
            open,
            setOpen
        }

        if (open){
            httpCall.get(`AuthorHistory/${getContentId()}`).then((({data}:{data:IAuthorHistory}) => {
                setHistory(data)         
            }))
            .catch((e) => {
                console.error(`Author history error: ${e}`)
            });
        }
    }, [open]);

    function download(){
        window.location.href = `${window.location.origin}/api/AuthorHistory/${getContentId()}/download`
    }

    function getContentId(){
        const match = window.location.pathname.match(/.*\/(\d+)/);

        if (match && match.length === 2){
            const contentId = parseInt(match[1]);
            if (contentId && Number.isInteger(contentId) ){
                return contentId
            }
        }
        return 0
    }
    

    return (
        <ModalWrapper  className="author-history-modal" isOpen={open} escClose={true} onRequestClose={() => setOpen(false)}>      
                        
            <h1>Author History</h1>

            {history && 
                <div className='author-grid'>

                    <div>                   
                        {history.originalAuthor ? 
                            <>
                                <div className='overview'>
                                    <div>
                                        <img src={`${BuildPath()}/images/icons/orginalauthor.svg`} alt="" />
                                        <h2>Original Author</h2>
                                    </div>
                                    
                                    <h3>{history.originalAuthor.name}</h3>
                                </div>
                                <div className='detail'>
                                    <UserDetails user={history.originalAuthor} />
                                </div>
                            </>
                        :
                            <div className='deleted'>
                                 <div>
                                    <img src={`${BuildPath()}/images/icons/orginalauthor.svg`} alt="" />
                                    <h2>Original Author</h2>
                                </div>
                                
                                <h3>Deleted User</h3>
                            </div>
                        }
                    </div>

                    <div>
                        {history.originalPublisher && history.hasEverBeenPublished ? 
                            <>
                                <div className='overview overview-orginal-pub'>
                                    <div>
                                        <img src={`${BuildPath()}/images/icons/orginalpublisher.svg`} alt="" />
                                        <h2>Original Publisher</h2>
                                    </div>

                                    {history.originalPublisher && 
                                        <>
                                            <h3>{history.originalPublisher.name}</h3>
                                            
                                            {history.originalPublishDate &&
                                                <h4>{new Date(history.originalPublishDate).toLocaleDateString()}</h4>
                                            }
                                        </>
                                    }
                                </div>

                                <div className='detail'>
                                    {history.originalPublisher ? <UserDetails user={history.originalPublisher} /> : <div className='na'>N/A</div>}         
                                </div>
                            </>            
                        :
                            <div className='deleted'>
                                <div>
                                    <img src={`${BuildPath()}/images/icons/orginalpublisher.svg`} alt="" />
                                    <h2>Original Publisher</h2>
                                </div>
                            
                                <h3>{history.hasEverBeenPublished ? "Deleted User" : "N/A"}</h3>
                            </div>   
                        }       
                    </div>

                    <div>
                        {history.lastEditedBy ? 
                            <>
                                <div className='overview'>
                                    <div>
                                        <img src={`${BuildPath()}/images/icons/lastedited.svg`} alt="" />
                                        <h2>Last Edited By</h2>
                                    </div>
                                    <h3>{history.lastEditedBy.name}</h3>
                                </div>
                                <div className='detail'>
                                    <UserDetails user={history.lastEditedBy} />
                                </div>
                            </>
                        :
                            <div className='deleted'>
                                <div>
                                    <img src={`${BuildPath()}/images/icons/lastedited.svg`} alt="" />
                                    <h2>Last Edited By</h2>
                                </div>
                            
                                <h3>Deleted User</h3>
                            </div>   
                        }
                    </div>
 
                    <div>                    
                        <div className='lastupdate'>
                            <div>
                                <img src={`${BuildPath()}/images/icons/lastupdate.svg`} alt="" />
                                <h2>Last Update</h2>
                            </div>
                            <h3>{new Date(history.lastUpdate).toLocaleDateString()}</h3>
                        </div>
                    </div>
                </div>
            }

            <div className="footer-controls">
                <BasicButton
                    isClassicThriveStyle
                    content={"Download Author History"} 
                    ariaLabel={'Download Author History'}
                    onButtonClick={download}
                />

                <BasicButton 
                    className='close-modal-button'
                    content={"Close"} 
                    ariaLabel={'Close modal'}
                    onButtonClick={()=>setOpen(false)}
                />
            </div>    
        </ModalWrapper>    
    )

}
    
export default AuthorHistoryModal